const state = {
  selectedTab: '1'
}

const mutations = {
  updateSelectedTab (state, selection) {
    state.selectedTab = selection
  }
}

const getters = {
  selectedTab: state => {
    return state.selectedTab
  }
}

export default {
  state,
  mutations,
  getters
}
